import Swiper, { Navigation, Autoplay } from 'swiper';

export function storiesSlider(element) {
        const swiper = new Swiper( element, {
            modules: [Navigation, Autoplay],
            slidesPerView: 'auto',
            loop: true,
            autoplay: {
                delay: 8000,
              },
            navigation: {
                nextEl: ".swiper-button-next"
            }
        }
    );
}
